'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { pushToDataLayer } from '@/util/analytics';
import { useUserProfile } from '@/contexts/UserProfileContext';

export default function PageViewTracker() {
  const pathname = usePathname();
  const { isLoading } = useUserProfile();

  useEffect(() => {
    const trackPageView = async () => {
      try {
        // Wait for user profile to finish loading
        // By the time isLoading is false, window.sug_memberinfo is already populated
        if (isLoading) {
          return;
        }

        await pushToDataLayer(
          {
            event: 'page_view',
            page_category: pathname,
            content_type: 'all_page_content',
          },
          {
            autoUserContext: true,
          }
        );
      } catch (error) {
        console.error(
          'Error tracking page view:',
          error instanceof Error ? error.message : 'Unknown error'
        );
      }
    };

    trackPageView();
  }, [pathname, isLoading]);

  return null;
}
